import React, { useEffect, useState } from 'react';
import useFetch from 'use-http';
import PersonnelPaperworkInfo from 'src/models/personnel/PersonnelPaperworkInfo';
import moment from 'moment';
import LoadingSpinner from 'src/components/common/LoadingSpinner';
import TSDILandman from 'src/models/personnel/TSDILandman';
import { FaEye, FaUpload } from 'react-icons/fa';
import Button from 'src/components/controls/forms/redesign/FormButton';

interface IPersonnelPaperworkDocs {
    showDialog: (dialogName: string) => void;
    hideDialog: () => void;
    selectedPersonnel?: TSDILandman;
    showPaperworkDialog: (categoryName: string, type: string, id: number) => void;
    showDocumentUploadDialog: (categoryName: string) => void;
    showToast: (message: string, color?: string, persistent?: boolean) => void;
    refresh: number;
}

const PersonnelPaperworkDocs = (props: IPersonnelPaperworkDocs) => {
    const { get, response } = useFetch();
    const [paperworkDocCountData, setPaperworkDocCountData] = useState<Array<PersonnelPaperworkInfo>>(undefined); // table display information
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setPaperworkDocCountData(undefined);
        getPaperworkData();
    }, [props.selectedPersonnel]);

    useEffect(() => {
        setPaperworkDocCountData(undefined);
        getPaperworkData();
    }, [props.refresh]);

    const getPaperworkData = async () => {
        setIsLoading(true);

        if (props.selectedPersonnel === undefined) {
            props.showToast('Selected personnel is undefined', `rgba(255,0,0,0.5)`);
            setPaperworkDocCountData(undefined);
            setIsLoading(false);
            return;
        }

        // if there is not a record in the LM table for the employee (highly unlikely, but possible)
        if (props.selectedPersonnel.lmNo === null || props.selectedPersonnel.lmNo <= 0) {
            props.showToast('Invalid employee number attached to personnel', `rgba(255,0,0,0.5)`);
            setPaperworkDocCountData(undefined);
            setIsLoading(false);
            return;
        }

        let result = await get(`/v1.0/landmen/personnel/${props.selectedPersonnel?.lmNo}/get-paperwork-information`);

        if (response.ok) {
            if (result) {
                result?.forEach((document: PersonnelPaperworkInfo) => {
                    document.compDate = document.compDate ? moment(document.compDate).format('MM/DD/YYYY') as undefined as Date : null;
                });

                result = result?.filter((document: PersonnelPaperworkInfo) => document.category !== 'Employee New Hire Packet'); // temp solution, rewrite backend later?
            }

            setIsLoading(false);
            setPaperworkDocCountData(result);
        } else {
            setIsLoading(false);
            props.showToast('Unable to fetch insurance documents', `rgba(255,0,0,0.5)`);
        }
    };

    // dialogs start
    const showFilesInCategory = (category: string, id: number) => {
        props.showPaperworkDialog(category, 'paperwork', id);
    };

    const openUploadDocumentDialog = (category: string) => {
        props.showDocumentUploadDialog(category);
    };
    // dialogs end

    // displaying paperwork information
    const displayRows = () => {
        return (
            paperworkDocCountData?.map((category, index) => (
                <div
                    style={{ display: 'flex', borderBottom: '1px solid darkgrey' }}
                    className="mb-2"
                >
                    <div style={{ width: '60%', textAlign: 'left' }}>{category.category}</div>
                    <div style={{ width: '20%', textAlign: 'left' }}>{category.compDate ? category.compDate : ''}</div>
                    <div style={{ width: '10%', textAlign: 'left' }}>{category.docs}</div>
                    <div style={{ width: '10%', textAlign: 'left' }}>
                        <Button
                            text={''}
                            title="View All Category Files"
                            reactIcon={FaEye}
                            iconHoverColor="lightblue"
                            iconStyle={{ fontSize: '1.7rem', color: '#4e759a' }}
                            style={{ background: 'none', border: 'none', padding: '5%', cursor: 'pointer' }}
                            onClick={() => showFilesInCategory(category.category, category.id)}
                        />
                        <Button
                            text={''}
                            title="Upload Document"
                            reactIcon={FaUpload}
                            iconHoverColor="lightblue"
                            iconStyle={{ fontSize: '1.7rem', color: '#4e759a' }}
                            style={{ background: 'none', border: 'none', padding: '5%', cursor: 'pointer' }}
                            onClick={() => openUploadDocumentDialog(category.category)}
                        />
                    </div>
                </div>
            ))
        );
    };

    return (
        <>
            {isLoading && (
                <div
                    style={{
                        top: 0,
                        left: 0,
                        position: 'absolute',
                        width: '100%',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999,
                    }}
                >
                    <LoadingSpinner />
                </div>
            )}
            <div>
                <div>
                    <div style={{ display: 'flex' }}>
                        <div style={{ width: '60%', textAlign: 'left', fontSize: '1.6rem', fontWeight: 'bold' }}>Document Name</div>
                        <div style={{ width: '20%', textAlign: 'left', fontSize: '1.6rem', fontWeight: 'bold' }}>Comp. Date</div>
                        <div style={{ width: '10%', textAlign: 'left', fontSize: '1.6rem', fontWeight: 'bold' }}>Docs</div>
                        <div style={{ width: '10%', textAlign: 'left', fontSize: '1.6rem', fontWeight: 'bold' }}>Actions</div>
                    </div>
                    {displayRows()}
                </div>
            </div>
        </>
    );
};

export default PersonnelPaperworkDocs;



// WEBPACK FOOTER //
// ./src/components/personnel/components/PersonnelPaperworkDocs.tsx